/* La Maison Para — carrousels automatiques toutes les 2 secondes.
   Accueil: collections, produits, packs, marques mobile, conseils mobile, avis Judge.me.
   Fiches produit: recommandations et produits récemment vus (uniquement l'onglet visible).
   Le diaporama principal conserve son lecteur natif (e-hero-enterprise.js). */
(function () {
  'use strict';
  if (window.__lmpAutoCarousels2s) return;
  window.__lmpAutoCarousels2s = true;

  var DELAY = 2000;
  // Avoid repeated DOM reads while visitors are interacting with the page.
  var lastGlobalInteraction = 0;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var hoverDevice = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  var rootSelector = '.e-collections--carousel, [data-e-featured-products], .e-marques-enterprise, .e-advice, .lmp-home-reviews, .product-recommendations';
  var selectors = [
    '.e-collections--carousel [data-e-collections-viewport]',
    '[data-e-featured-products] [data-e-products-viewport]',
    '.e-marques-enterprise__viewport',
    '.e-advice__cards'
  ];

  // Cache les composants afin de ne pas parcourir le document toutes les 2 secondes.
  // L'IntersectionObserver évite les calculs géométriques sur les blocs hors écran.
  var entries = new Map();
  var viewportObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function(changes) {
    changes.forEach(function(change) {
      var item = entries.get(change.target);
      if(item) item.visible = change.isIntersecting;
    });
  }, {threshold: 0.3}) : null;

  function registerCarousel(node, type) {
    if (!node || entries.has(node)) return;
    var item = {node: node, root: rootOf(node), type: type, visible: !viewportObserver};
    entries.set(node, item);
    if (viewportObserver) viewportObserver.observe(node);
  }

  function discoverCarousels() {
    if(document.hidden)return;
    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(node) {
        registerCarousel(node, 'scroll');
      });
    });
    document.querySelectorAll('.product-recommendations__row-wrapper.swiper-initialized.is-active').forEach(function(node) {
      registerCarousel(node, 'swiper');
    });
    document.querySelectorAll('.lmp-home-reviews .jdgm-carousel').forEach(function(node) {
      registerCarousel(node, 'reviews');
    });
    entries.forEach(function(item, node) {
      if (!node.isConnected) {
        if (viewportObserver) viewportObserver.unobserve(node);
        entries.delete(node);
      }
    });
  }

  function scheduleDiscovery() {
    if(document.hidden)return;
    if('requestIdleCallback' in window)window.requestIdleCallback(discoverCarousels, {timeout: 2000});
    else window.setTimeout(discoverCarousels, 0);
  }


  function rootOf(node) {
    return node.closest(rootSelector) || node;
  }

  function getActiveArea(root) {
    return root.getBoundingClientRect();
  }

  function canAdvance(root, node, item) {
    if (!root || !node || !root.isConnected) return false;
    if (document.hidden || (reducedMotion && reducedMotion.matches)) return false;
    // Autoplay in the public preview/storefront, not in the editor while arranging sections.
    if (window.Shopify && window.Shopify.designMode) return false;
    if (root.__lmpAutoPaused) return false;
    if (root.__lmpLastInteraction && Date.now() - root.__lmpLastInteraction < 5000) return false;
    if (hoverDevice && hoverDevice.matches && root.matches(':hover')) return false;
    var active = document.activeElement;
    if (active && node.contains(active) && active !== document.body) return false;
    if (viewportObserver) {
      if (!item || !item.visible) return false;
    } else {
      var area = getActiveArea(root);
      if (area.width < 20 || area.height < 20) return false;
      if (area.bottom < window.innerHeight * 0.1 || area.top > window.innerHeight * 0.9) return false;
    }
    return true;
  }

  function slideOne(node) {
    if (!node || node.clientWidth < 50) return;
    var max = node.scrollWidth - node.clientWidth;
    if (max < 8) return; // Grille fixe ou moins de cartes que la largeur disponible.
    var row = node.matches('.e-advice__cards') ? node : node.firstElementChild;
    var card = row && row.firstElementChild;
    var gap = row ? parseFloat(window.getComputedStyle(row).columnGap) || 0 : 0;
    var step = card ? card.getBoundingClientRect().width + gap : node.clientWidth * 0.65;
    if (!Number.isFinite(step) || step < 20) step = node.clientWidth * 0.65;
    var current = Math.max(0, node.scrollLeft);
    var next = current >= max - 3 ? 0 : Math.min(max, current + step);
    node.scrollTo({ left: next, behavior: 'smooth' });
  }

  function moveSwiper(wrapper) {
    if (!wrapper.classList.contains('is-active')) return;
    var slider = wrapper.swiper;
    if (!slider || slider.destroyed || !slider.slides || slider.slides.length < 2) return;
    if (slider.isLocked || !slider.allowSlideNext && !slider.allowSlidePrev) return;
    if (slider.isEnd) slider.slideTo(0, 550);
    else slider.slideNext(550);
  }

  function moveReviews(carousel) {
    var slides = carousel.querySelectorAll('.jdgm-carousel-item');
    if (slides.length < 2) return;
    var next = carousel.querySelector('.jdgm-carousel__right-arrow');
    if (next && next.getClientRects().length) next.click();
  }

  function tick() {
    if (document.hidden || (lastGlobalInteraction && Date.now() - lastGlobalInteraction < 5000)) return;
    if (reducedMotion && reducedMotion.matches) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (navigator.scheduling && typeof navigator.scheduling.isInputPending === 'function' && navigator.scheduling.isInputPending({ includeContinuous: true })) return;

    entries.forEach(function(item, node) {
      if (!node.isConnected) {
        if (viewportObserver) viewportObserver.unobserve(node);
        entries.delete(node);
        return;
      }
      if (!canAdvance(item.root, node, item)) return;
      if (item.type === 'scroll') slideOne(node);
      else if (item.type === 'swiper') moveSwiper(node);
      else if (item.type === 'reviews') moveReviews(node);
    });
  }

  function pauseAfterUserAction(event) {
    if (event.isTrusted === false) return;
    lastGlobalInteraction = Date.now();
    var root = event.target && event.target.closest && event.target.closest(rootSelector);
    if (root) root.__lmpLastInteraction = Date.now();
  }

  document.addEventListener('pointerdown', pauseAfterUserAction, true);
  document.addEventListener('keydown', pauseAfterUserAction, true);
  document.addEventListener('wheel', pauseAfterUserAction, { capture: true, passive: true });
  document.addEventListener('touchstart', pauseAfterUserAction, { capture: true, passive: true });

  // Découverte lors du chargement, puis rafraîchissement léger des contenus dynamiques.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleDiscovery, {once: true});
  else scheduleDiscovery();
  document.addEventListener('shopify:section:load', scheduleDiscovery);
  document.addEventListener('shopify:section:unload', scheduleDiscovery);
  document.addEventListener('visibilitychange', function(){if(!document.hidden)scheduleDiscovery();});
  window.addEventListener('pageshow', scheduleDiscovery);
  window.setInterval(scheduleDiscovery, 30000);
  // Les défilements automatiques s'exécutent en période libre pour ne pas retarder un clic.
  var lmpAutoIdlePending = false;
  function tickWhenIdle() {
    if (lmpAutoIdlePending || document.hidden) return;
    lmpAutoIdlePending = true;
    var run = function() {
      lmpAutoIdlePending = false;
      tick();
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 1200 });
    else window.setTimeout(run, 100);
  }
  window.setInterval(tickWhenIdle, DELAY);
})();